import useStore from '../stores/store';

export const showToast = (title, subtitle, type, resClick = null) => {
    useStore.getState().setShowToast(title, subtitle, type, resClick);
};
